// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tzRst","title":"styles_title__pTOje","containerWithTitle":"styles_containerWithTitle__n5air","content":"styles_content__2y4Cc"};